module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("Season of Sacrifice")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "../styles/styles.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('link', {
    attrs: {
      "href": "../styles/additional.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "books-by-head"
  }, [_vm._v("About the Author")]), _vm._v(" "), _c('p', {
    staticClass: "author-text"
  }, [_vm._v("Bharti Kirchner is the author of seven critically acclaimed novels, four cookbooks and hundreds of short pieces which were published in magazines and newspapers. Bharti has written for "), _c('em', [_vm._v("Food & Wine, Writer’s Digest, The Writer, Fitness Plus, San Francisco Chronicle")]), _vm._v(" and "), _c('em', [_vm._v("The Seattle Times")]), _vm._v(". Her essays have appeared in ten anthologies. She has won numerous awards for her writing, including a Virginia Center for the Creative Arts Fellowship. Prior to becoming a writer, Bharti worked as a systems engineer for IBM and as a systems manager for Bank of America, San Francisco. She has also worked in Europe and other continents as a computer systems consultant. Bharti lives in the US with her husband. Visit "), _c('a', {
    attrs: {
      "href": "http://www.bhartikirchner.com",
      "target": "_blank"
    }
  }, [_vm._v("www.bhartikirchner.com")]), _vm._v(" for more details.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-663f9a2c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/aboutauthor.vue
// module id = 66
// module chunks = 0